import ApiService from "@/services/api.service";
import SettingsService from "@/services/settings.service";
import mocks from "./mocksExternalPension.json";

const state = {
  access: undefined,
  summary: undefined,
  statements: undefined,
};

const getters = {
  access: (state) => state.access,
  summary: (state) => state.summary,
  statements: (state) => state.statements,
};

// demo and local plans use mocks, same as data.module
const useMocks = (rootGetters) =>
  rootGetters["common/isDemoMockPlan"] || rootGetters["common/isLocalPlan"];

const reportUrl = ({ memberId, statementId, reportId }) =>
  `${SettingsService.settings.APIURL}external-pension/members/${memberId}/statements/${statementId}/reports/${reportId}`;

const actions = {
  // whether this member gets the feature at all; answers 200 either way
  async loadAccess({ commit, rootGetters }, memberId) {
    const url = `${SettingsService.settings.APIURL}external-pension/members/${memberId}/access`;
    const access = useMocks(rootGetters)
      ? mocks.access
      : (await ApiService.get(url)).data;
    commit("setAccess", access);
    return access;
  },
  // null means the member is not linked to an external pension, which the service answers with a 404
  async loadSummary({ commit, rootGetters }, memberId) {
    const url = `${SettingsService.settings.APIURL}external-pension/members/${memberId}/summary`;
    let summary = null;
    try {
      summary = useMocks(rootGetters)
        ? mocks.summary
        : (await ApiService.get(url)).data;
    } catch (error) {
      summary = null;
    }
    commit("setSummary", summary);
    return summary;
  },
  async loadStatements({ commit, rootGetters }, memberId) {
    const url = `${SettingsService.settings.APIURL}external-pension/members/${memberId}/statements`;
    const statements = useMocks(rootGetters)
      ? mocks.statements
      : (await ApiService.get(url)).data;
    // most recent date first
    const sorted = [...(statements || [])].sort((a, b) =>
      b.AsAtDate.localeCompare(a.AsAtDate)
    );
    commit("setStatements", sorted);
    return sorted;
  },
  async loadReport({ rootGetters }, options) {
    return useMocks(rootGetters)
      ? mocks.reports[options.statementId][options.reportId]
      : (await ApiService.get(reportUrl(options))).data;
  },
  async downloadReport({ rootGetters }, options) {
    if (useMocks(rootGetters)) {
      const bytes = Uint8Array.from(atob(mocks.statementDocumentBase64), (c) =>
        c.charCodeAt(0)
      );
      return new Blob([bytes], { type: "application/pdf" });
    }
    return (await ApiService.download(`${reportUrl(options)}/document`)).data;
  },
};

const mutations = {
  setAccess(state, value) {
    state.access = value;
  },
  setSummary(state, value) {
    state.summary = value;
  },
  setStatements(state, value) {
    state.statements = value;
  },
};

export const externalPension = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
